import '../styles/video.scss';
import Lottie from 'react-lottie';
import lottie1 from '../assets/lotties/enfamil_1.json';
import lottie2 from '../assets/lotties/enfamil_2.json';
const Video = () => {
  const lottie1Options = {
    loop: true,
    autoplay: true,
    animationData: lottie1,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };
  const lottie2Options = {
    loop: true,
    autoplay: true,
    animationData: lottie2,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  return (
    <div className="video">
      <div className="video__introP">
        <p>
          Today, the people at Enfamil are demonstrating why Enfamil is the infant formula brand
          most trusted by parents and pediatricians<sup>1</sup> as they continue their relentless
          response to the crisis. <span className="bold">This is their story.</span>
        </p>
      </div>
      <div class="video__vimeoVideo">
        <iframe
          src="https://player.vimeo.com/video/820564712?h=de5b1318df"
          frameborder="0"
          allow="fullscreen; picture-in-picture"
          allowfullscreen
          title="Legacy of Change"
        ></iframe>
        <script src="https://player.vimeo.com/api/player.js"></script>
      </div>
      <div className="video__paragraphs">
        <div className="graphic1">
          {/* <img src={graphic1} alt="colorful grpahic" /> */}
          <Lottie options={lottie1Options} />
        </div>
        <p>
          In early 2022, when a combination of factors— including post pandemic supply chain snags
          and a factory shutdown by a major manufacturer— led to a startling shortage of infant
          formula, parents and caregivers were left wondering how they would feed their children.{' '}
          <span className="bold">
            But the Enfamil team<sup>2</sup> was ready to to step up in a time of crisis.
          </span>
        </p>
        <p>
          At Enfamil, the shortage was a <span className="bold">call to action.</span> From
          employees on the factory floors and call center front lines to quality experts and
          executives at corporate headquarters, the entire company came together with an urgent
          mission:{' '}
          <span className="bold">to keep shelves stocked with a high-quality formula.</span>
        </p>

        <div className="graphic2">
          {/* <img src={graphic2} alt="colorful grpahic" /> */}
          <Lottie options={lottie2Options} />
        </div>
      </div>
    </div>
  );
};

export default Video;
